module.exports = __webpack_public_path__ + "img/59.970145f5.png";